export interface HeroSlide {
  id: string;
  mediaId: string;
  tag: string;
  title: string;
  subtitle: string;
  image: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "hero-1",
    mediaId: "m1",
    tag: "独家首推 · 科幻巨制",
    title: "深空回响",
    subtitle:
      "一支深空探测队收到来自木星轨道的神秘信号，真相将彻底改写人类对宇宙的认知。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20hero%20banner%2C%20a%20lone%20astronaut%20silhouette%20before%20a%20colossal%20glowing%20orange%20planet%20in%20deep%20space%2C%20epic%20immense%20scale%2C%20rich%20warm%20orange%20and%20teal%20palette%2C%20dramatic%20atmospheric%20lighting%2C%20high%20detail%20digital%20painting%2C%20no%20text%20no%20letters&width=1600&height=900&seq=po18-hero-1&orientation=landscape",
  },
  {
    id: "hero-2",
    mediaId: "t10",
    tag: "口碑剧集 · 悬疑热榜",
    title: "悬案档案",
    subtitle:
      "一个专门重启冷案的特别小组，从尘封档案中寻找被时间掩盖的真相。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20hero%20banner%2C%20a%20dim%20investigation%20room%20with%20stacked%20cold%20case%20files%20and%20a%20single%20warm%20lamp%2C%20tense%20mysterious%20atmosphere%2C%20warm%20orange%20spotlight%20against%20deep%20shadow%2C%20high%20detail%20illustration%2C%20no%20text%20no%20letters&width=1600&height=900&seq=po18-hero-2&orientation=landscape",
  },
  {
    id: "hero-3",
    mediaId: "v10",
    tag: "综艺热播 · 舞蹈竞演",
    title: "舞蹈风暴",
    subtitle:
      "顶尖舞者同台竞演，从民族舞到街舞，用身体讲述故事、释放情感。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20hero%20banner%2C%20a%20dancer%20mid%20leap%20on%20a%20grand%20stage%20under%20dramatic%20orange%20spotlights%20with%20motion%20trails%2C%20passionate%20energetic%20mood%2C%20warm%20gold%20and%20amber%20tones%2C%20high%20detail%20illustration%2C%20no%20text%20no%20letters&width=1600&height=900&seq=po18-hero-3&orientation=landscape",
  },
  {
    id: "hero-4",
    mediaId: "m6",
    tag: "冒险科幻 · 视觉盛宴",
    title: "山海秘语",
    subtitle:
      "地质学家在远古洞穴中发现违背常理的遗迹，人类与神秘山海世界的通道正被打开。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20hero%20banner%2C%20explorers%20before%20a%20colossal%20mystic%20cavern%20with%20glowing%20amber%20crystals%20and%20ancient%20ruins%2C%20epic%20adventure%20wonder%2C%20warm%20orange%20and%20teal%20palette%2C%20high%20detail%20digital%20painting%2C%20no%20text%20no%20letters&width=1600&height=900&seq=po18-hero-4&orientation=landscape",
  },
];